var ctcFundDataJSON = '';
ctcFundDataJSON = {
		"fundList": [{
			"ID": "GB00BYXD5D11",
			"Name": "PRUFUND CAUTIOUS FUND SERIES E",
			"growthRate": {
				"rate": "Medium",
				"value": "5.50"
			},
			"Expense": [{
				"type": "AMC",
				"rate": {
					"value": "0.65"
				}
			}, {
				"type": "CGTE",
				"charges": [{
					"term": "10",
					"value": "1.00"
				}, {
					"term": "11",
					"value": "0.90"
				}, {
					"term": "12",
					"value": "0.80"
				}, {
					"term": "13",
					"value": "0.70"
				}, {
					"term": "14",
					"value": "0.60"
				}, {
					"term": "15",
					"value": "0.50"
				}]
			}, {
				"type": "IGTE",
				"charges": [{
					"term": "1",
					"value": "0.95"
				}],
				"GIR": [{
					"age": "55",
					"value": "3.10"
				}, {
					"age": "56",
					"value": "3.15"
				}, {
					"age": "57",
					"value": "3.25"
				}, {
					"age": "58",
					"value": "3.30"
				}, {
					"age": "59",
					"value": "3.35"
				}, {
					"age": "60",
					"value": "3.45"
				}, {
					"age": "61",
					"value": "3.55"
				}, {
					"age": "62",
					"value": "3.60"
				}, {
					"age": "63",
					"value": "3.70"
				}, {
					"age": "64",
					"value": "3.80"
				}, {
					"age": "65",
					"value": "3.90"
				}, {
					"age": "66",
					"value": "4.00"
				}, {
					"age": "67",
					"value": "4.10"
				}, {
					"age": "68",
					"value": "4.25"
				}, {
					"age": "69",
					"value": "4.35"
				}, {
					"age": "70",
					"value": "4.50"
				}, {
					"age": "71",
					"value": "4.65"
				}, {
					"age": "72",
					"value": "4.80"
				}, {
					"age": "73",
					"value": "4.95"
				}, {
					"age": "74",
					"value": "5.10"
				}, {
					"age": "75",
					"value": "5.30"
				}]
			}]
		}, {
			"ID": "GB00BYXD5G42",
			"Name": "PRUFUND GROWTH FUND SERIES E",
			"growthRate": {
				"rate": "Medium",
				"value": "6.20"
			},
			"Expense": [{
				"type": "AMC",
				"rate": {
					"value": "0.65"
				}
			}, {
				"type": "CGTE",
				"charges": [{
					"term": "10",
					"value": "1.50"
				}, {
					"term": "11",
					"value": "1.40"
				}, {
					"term": "12",
					"value": "1.30"
				}, {
					"term": "13",
					"value": "1.15"
				}, {
					"term": "14",
					"value": "1.00"
				}, {
					"term": "15",
					"value": "0.90"
				}]
			}]
		}, {
			"ID": "GB00BYXD5423",
			"Name": "PRUFUND 0-30 FUND SERIES E",
			"growthRate": {
				"rate": "Medium",
				"value": "5.10"
			},
			"Expense": [{
				"type": "AMC",
				"rate": {
					"value": "0.65"
				}
			}]
		}, {
			"ID": "GB00BYXD5647",
			"Name": "PRUFUND 10-40 FUND SERIES E",
			"growthRate": {
				"rate": "Medium",
				"value": "5.50"
			},
			"Expense": [{
				"type": "AMC",
				"rate": {
					"value": "0.65"
				}
			}]
		}, {
			"ID": "GB00BYXD5860",
			"Name": "PRUFUND 20-55 FUND SERIES E",
			"growthRate": {
				"rate": "Medium",
				"value": "6.10"
			},
			"Expense": [{
				"type": "AMC",
				"rate": {
					"value": "0.65"
				}
			}]
		}, {
			"ID": "GB00BYXD5B96",
			"Name": "PRUFUND 40-80 FUND SERIES E",
			"growthRate": {
				"rate": "Medium",
				"value": "6.30"
			},
			"Expense": [{
				"type": "AMC",
				"rate": {
					"value": "0.65"
				}
			}]
		}]
	};

module.exports = {
  ctcFundDataJSON
}



// WEBPACK FOOTER //
// ./src/calculator/ctcFundData.js